
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/case-tracker",
      function () {
        return require("private-next-pages/case-tracker.tsx");
      }
    ]);
  